module.exports = __webpack_public_path__ + "img/logos_telegram.f71e47b1.png";